import * as React from 'react';
import { AddFiltersButton } from 'app/components/filters/add-filters/add-filters-button';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { AddFiltersSelect } from 'app/components/filters/add-filters/add-filters-select';
import { AdvancedSearchOption } from 'app/area/filters/types';
import { mapToAdvancedSearchTypes } from 'app/area/filters/filters-mapping';
import { ModalSize } from 'app/components/constants';
import { AddFiltersButtonInline } from 'app/components/filters/add-filters/add-filters-button-inline';

export interface AddFiltersProps {
  positionInline: boolean;
  options?: any;
  translation?: any;
  locale: string;
  onAddNewFilters?: (options: any) => any;
  onLoadAdvancedSearchFields: (query?: string) => any;
}

export interface AddFiltersState {
  isOpen: boolean;
  valueItems: any;
}

export class AddFilters extends React.PureComponent<AddFiltersProps, AddFiltersState> {
  public state: Readonly<AddFiltersState> = {
    isOpen: false,
    valueItems: []
  };

  private handleToggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    } as AddFiltersState);
  };

  private handleAddValueItems = () => {
    this.props.onAddNewFilters(mapToAdvancedSearchTypes(this.state.valueItems.map(item => ({
      ...item
    }))));
    this.clearValueItems();
  };

  private onFiltersListChange = (valueItems: AdvancedSearchOption[]) => {
    this.setState({
      valueItems
    } as AddFiltersState);
  };

  private isDisabled = () => {
    return this.state.valueItems.length > 0 ? false : true;
  };

  private clearValueItems = () => {
    this.setState({
      valueItems: []
    } as AddFiltersState);
  };

  private handleClose = () => {
    this.handleToggle();
    this.handleAddValueItems();
  };

  private renderFiltersModal = () => {
    return <ModalWrapper
      headerTitle={this.props.translation.add_filters_modal_title}
      btnTitle={this.props.translation.add_filters_modal_add_button}
      onClose={this.handleClose}
      onDone={this.handleAddValueItems}
      isDisabled={this.isDisabled}
      size={ModalSize.large}>
      {<AddFiltersSelect
        translation={this.props.translation}
        options={this.props.options}
        valueItems={this.state.valueItems}
        onChange={this.onFiltersListChange}
        onLoadAdvancedSearchFields={this.props.onLoadAdvancedSearchFields}
        locale={this.props.locale}
      />}
    </ModalWrapper>;
  };

  public render() {
    const props = {
      title: this.props.translation && this.props.translation.add_filters_button_title,
      onOpen: this.handleToggle
    };

    return (
      <div>
        {!!this.props.positionInline
          ? <AddFiltersButtonInline {...props} />
          : <AddFiltersButton {...props} />}
        {this.state.isOpen && this.renderFiltersModal()}
      </div>
    );
  }
}
